import { ButtonMicrophone } from '@/components/ButtonMicrophone'
import { LinkLeave } from '@/components/LinkLeave'
import { TEST_IDS } from '@/helpers/constants'
import type { RedirectPath } from '@/helpers/types'
import { useRoomStore } from '@/stores/room'
import { ButtonAddVideo } from './ButtonAddVideo'
import { useSelfMicrophoneButtonState } from '@/hooks/useSelfMicrophoneButtonState'

interface AudioCallControlsProps {
  redirect?: RedirectPath | undefined
}

export const AudioCallControls = ({ redirect }: AudioCallControlsProps) => {
  const callState = useRoomStore(state => state.callState)
  const { isMicrophoneButtonVisible, isMicrophoneEnabled } =
    useSelfMicrophoneButtonState()

  const callJoined = callState === 'joined'

  return (
    <menu
      aria-label="Room toolbar"
      className="flex flex-col"
      data-testid={TEST_IDS.ROOM_CONTROLS}
      role="toolbar"
    >
      <li>
        <ul
          aria-label="Audio and video controls"
          className="flex gap-2 p-2.5"
          role="group"
        >
          <li className="flex min-w-[170px] items-center justify-center pb-4 pt-3">
            <ButtonMicrophone
              disabled={!callJoined || !isMicrophoneEnabled}
              isVisible={isMicrophoneButtonVisible}
            />
          </li>
          <li className="flex min-w-[170px] items-center justify-center pb-4 pt-3">
            <ButtonAddVideo disabled={!callJoined} />
          </li>
        </ul>
      </li>
      <li className="flex items-center justify-center py-20">
        <LinkLeave to={redirect} variant="rounded" />
      </li>
    </menu>
  )
}
